"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _ActiveHubSelectors = require("pricing-pages-unified-ui/selectors/ActiveHubSelectors");

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var AnnualDiscountLegalDisclaimer = function AnnualDiscountLegalDisclaimer(_ref) {
  var activeHub = _ref.activeHub,
      isAnnualDiscountEligible = _ref.isAnnualDiscountEligible;
  var notOnPrimaryHubPages = !activeHub;
  if (notOnPrimaryHubPages || !isAnnualDiscountEligible) return null;
  return _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.annualDiscountLegalDisclaimer." + activeHub
  });
};

AnnualDiscountLegalDisclaimer.propTypes = {
  activeHub: _propTypes.default.string,
  isAnnualDiscountEligible: _propTypes.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var activeEdition = _ref2.activeEdition;
  var isInMCBeta = (0, _MarketingContactsSelectors.isInMCBetaSelector)(state);
  var activeHub = (0, _ActiveHubSelectors.activeHubSelector)(state);
  var isAnnualDiscountEligible = !!activeHub && (0, _PromotionSelectors.isAnnualDiscountEligibleSelector)(state, (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[activeEdition][activeHub]);
  return {
    activeHub: isInMCBeta && activeHub === _Hubs.default.HUB_MARKETING ? 'marketingContacts' : _Hubs.default.HUB_MARKETING,
    isAnnualDiscountEligible: isAnnualDiscountEligible
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(AnnualDiscountLegalDisclaimer);

exports.default = _default;
module.exports = exports.default;